export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ //eslint-disable-line

export const HOST_API = import.meta.env.VITE_HOST_API
export const ECS_API = import.meta.env.VITE_ECS_API
export const SAP_API = `${ECS_API}/sap`
export const IMPORT_API = `${HOST_API}`
// MSAL
export const MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID
export const MSAL_AUTHORITY = import.meta.env.VITE_MSAL_AUTHORITY
export const MSAL_REDIRECT_URI = import.meta.env.VITE_MSAL_REDIRECT_URI

export const STORAGE_KEY = 'accessToken'
export const REFRESH_TOKEN_KEY = 'refreshToken'
export const AUTH_TYPE_KEY = 'authType'
export const AUTH_TYPE_MSAL = 'msal'
export const AUTH_TYPE_LOCAL = 'local'

export const WITHOUT_PAGINATION = { limit: 999999 }
export const WITHOUT_PAGINATION_LIMIT = 999999
export const FIVE_MINUTES = 300_000

export const AVATAR_BG_COLORS = [
  '#a2d3fe',
  '#fc6814',
  '#09cd67',
  '#fecd00',
  '#a9d9d6',
]

export const PAGINATION_INITIAL_STATE = {
  page: 1,
  limit: 50,
  recordsCount: 0,
}

export const COMPANIES_ID = {
  brazil: 'c0675a7e-a4d0-4517-8fd4-2c45feec8b36',
}

export const SALES_ORDER_TYPES = {
  industrial: '5c603cef-7947-4108-af32-9cc5b40db59e',
  automotive: '99f54291-82cb-4e60-8192-4f955542fca4',
  broker: 'b04ec188-f5eb-4902-810f-eaa26a821539',
}

export const ORDER_TYPES = {
  europeHana: '48b6ce1e-784e-47b1-a6e0-52fef5869b8d',
  china: '2d189444-5ccb-402d-9296-11eb5ced66d5',
  india: '7cd43c4b-dfcb-4c8d-958e-7dee7ee28e1b',
  asia: '81080e58-1dc3-43b6-aafa-f7ddb5f93290',
  brazil: [
    '901b9a44-ead2-456e-a063-caee92e787e5',
    '99f54291-82cb-4e60-8192-4f955542fca4',
    'b04ec188-f5eb-4902-810f-eaa26a821539',
    '2a0be5e7-27fe-4443-8dca-806ab749ab55',
    '19db4ebf-d5b7-427b-804e-60c7fbee2948',
    '5c603cef-7947-4108-af32-9cc5b40db59e',
    '8f7bfdc3-1722-4016-93a4-b46006326990',
    '35748490-3225-4234-9798-138030aa9202',
  ],
  argentina: [
    '5a045505-7d5c-4cc8-b7d6-62d68b3cc195',
    '4077a14b-19d1-422d-9ab3-b2f0cc85a814',
  ],
  b2b: {
    hyundai: '2bd51abc-edba-461d-a9a0-8e80181190ad',
    europe: '59bacd1a-48cf-465a-b76c-2136470def1a',
    india: 'c299557b-4936-4968-bbc8-7e42b2315222',
    asia: '562f655d-8a40-4d95-ab7d-c2027fff3dba',
    argentina: '85cc07b3-131b-452f-88b2-53571170fee4',
  },
}

export const RIGID_TYPES = {
  normal: 'd59b2c99-7414-48da-9860-61b864428e7d',
  rigid: '7e54e7db-7350-4cb9-a4d7-a80e05beea4b'
}

export const DATE_FORMATS = ['DD/MM/YYYY', 'DDMMYYYY', 'MM/DD/YYYY', 'MMDDYYYY']

export const TIME_ZONE_MAP: { [key: string]: string } = {
  'America/New_York': 'Eastern Standard Time',
  'America/Chicago': 'Central Standard Time',
  'America/Denver': 'Mountain Standard Time',
  'America/Los_Angeles': 'Pacific Standard Time',
  'America/Sao_Paulo': 'E. South America Standard Time',
  'America/Argentina/Buenos_Aires': 'Argentina Standard Time',
  'Europe/London': 'GMT Standard Time',
  'Europe/Berlin': 'W. Europe Standard Time',
  'Asia/Kolkata': 'India Standard Time',
  'Asia/Singapore': 'Singapore Standard Time',
  'Asia/Jakarta': 'SE Asia Standard Time',
  'Asia/Dubai': 'Arabian Standard Time',
}

export const Permissions = {
  case: {
    canRead: '4d5d58de-1b77-4ad4-8d71-2b4494b58dd9',
    canUpdate: 'c77e8150-ecdd-4e5d-83fc-54cd88cd717c',
    canReadAll: '598ec840-5b8a-4b6f-9e71-a4fd36078af3',
    createOrDelete: '1dfd8649-a5ba-49b7-a67c-06ea21c968df',
  },
  claim: {
    canCreateOrDelete: '0c851acf-2374-4869-86f5-a6f311ef97a2',
    canRead: 'e50fed55-0505-4416-b1cd-647f613ab09e',
    canApprovingCsCloseClaimEmea: 'f4df727a-dcf4-409d-b447-bf260cdb29f9',
  },
  creditLimit: {
    canReadCreditLimitRequestFinancialStatement:
      'f672fdc6-7fa9-4d1b-ac5a-6a29f81a81c9',
    canWriteCreditLimitRequestData: '69990c6b-cac2-4969-a7bf-a845bb3f29cb',
  },
  businessPartner: {
    canRead: '4e8a5d3c-24e9-4888-9997-461add80a0f6',
    canEditBusinessPartnerContact: '9b55bbb0-db18-4865-9088-97e72761d197',
    canEditBusinessPartnerCS: 'd789fd34-c1f8-4db6-b0d6-0653ac3d3275',
    canReadEditBusinessPartnerPricing: '9badb173-264d-4b0d-87c0-45c7c4a915f5',

    massUpdate: {
      canReadEdit: '11e94d20-6abd-43c3-a04d-b324699200a2',
    },
    automotiveDiscount: {
      canCreateEditOrDelete: '5a63d77b-bcb9-4878-8443-54c5e46070bb',
    },
  },
  pricing: {
    automotive: {
      table: {
        canCreateEditOrDelete: 'bf3b78ef-495e-4989-b4f4-bb6bc9b37239',
      },
      positioning: {
        canCreateEditOrDelete: '3424a5ff-fc0a-4d2c-a990-e68d2f481d69',
      },
      exception: {
        canCreateEditOrDelete: 'c8c22b16-563b-4584-8b11-0d29d5b3af6f',
      },
    },
    industrial: {
      table: {
        canCreateEditOrDelete: 'f1186f7d-630d-4377-a1d3-a7d7011f1991',
      },
      positioningCube: {
        canFullAccessPricingIndustrialPositionConfiguration:
          '71106397-59a9-4c23-846c-f45d0f5f841d',
      },
      group: {
        canCreateEditOrDelete: '6a0ccdf9-6aeb-4aeb-9518-fe00a7895664',
      },
    },
    exceptionByChannel: '6591326c-a684-4e31-9452-a03e6e083407',
    import: {
      can_full_access_pricing_others_import: '453fb85c-b341-4fea-a385-92b0eafa0ec1'
    }
  },
  contracts: {
    canCreateOrDeleteContract: 'afcaaed9-efec-4e58-ac19-bc19f3f50fcf',
  },
  salesOrder: {
    canReleaseFinancialBlock: '6a7b8c9d-e0f1-4007-a007-66778899aabb',
    internal: {
      brazil: {
        canCreate: '0a1b2c3d-4e5f-4001-a001-001122334455',
        can_mandate_attachment_brazil: '4e5f6a7b-8c9d-4005-a005-445566778899',
        canRemoveMaterial: '5f6a7b8c-9d0e-4006-a006-5566778899aa',
        canReadMarginOrderData: '7b8c9d0e-f102-4008-a008-778899aabbcc',
      },
      can_mandate_attachment_global: '4e5f6a7b-8c9d-4005-a005-445566778899',
      can_read_margin_order_data_global: '7b8c9d0e-f102-4008-a008-778899aabbcc',
      argentina: {
        sales_order_argentina_full_access:
          '62773862-4f2b-4a51-9e2e-21fd84dccdc2',
        can_see_net_price_argentina: 'd45a3b60-4243-4545-9f5d-14c187a16654',
      },
    },
    b2b: {
      argentina: {
        b2b_argentina_full_access:
          'fe8b3361-8693-4e05-b208-1ff1567ec51e',
      }
    }
  },
}

export enum SimulationStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  READY = 'ready',
}
